import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date('2027-01-27T00:00:00').getTime();
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const timeBlocks = [{
    label: 'Days',
    value: timeLeft.days
  }, {
    label: 'Hours',
    value: timeLeft.hours
  }, {
    label: 'Minutes',
    value: timeLeft.minutes
  }, {
    label: 'Seconds',
    value: timeLeft.seconds
  }];
  return <section className="py-24 bg-gradient-to-b from-rich-black to-[#050505] relative overflow-hidden border-y border-white/5" data-id="element-58">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 pointer-events-none" data-id="element-59" />

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-60">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="font-display text-3xl md:text-4xl font-bold mb-12 text-white" data-id="element-61">
          The world tour begins soon.
        </motion.h2>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-62">
          {timeBlocks.map((block, index) => <motion.div key={block.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-panel w-24 h-24 md:w-32 md:h-32 rounded-2xl flex flex-col items-center justify-center border border-gold/20 shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-63">
              <span className="font-display text-3xl md:text-5xl font-bold text-gradient-gold mb-1" data-id="element-64">
                {block.value.toString().padStart(2, '0')}
              </span>
              <span className="font-sans text-xs md:text-sm text-gray-400 uppercase tracking-widest" data-id="element-65">
                {block.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}